import axios from './axios';

export function createSystemParameter(data) {
    return axios.post('/api/system-parameters', data).then(res => res.data);
}

export function getSystemParameterById(id) {
    return axios.get(`/api/system-parameters/${id}`).then(res => res.data);
}



export function updateSystemParameter(id, data) {
    return axios.put(`/api/system-parameters/${id}`, data).then(res => res.data);
}

export function deleteSystemParameter(id) {
    return axios.delete(`/api/system-parameters/${id}`).then(res => res.status === 204);
}

export function getSystemParameterPage(queryRequest, pageable = { page: 0, size: 10 }) {
    const params = {
        ...queryRequest,
        ...pageable
    };
    return axios.get('/api/system-parameters/page', { params }).then(res => res.data);
}